import S3AnalyticsInfos from './S3AnalyticsInfosComponent';
import S3AnalyticsCharts from './S3AnalyticsChartsComponent';
import CostBreakdownPieChart from './CostBreakdownPieChartComponent';
import CostBreakdownBarChart from './CostBreakdownBarChartComponent';
import CostBreakdownInfos from './CostBreakdownInfosComponent';

export default {
  S3AnalyticsInfos,
  S3AnalyticsCharts,
  CostBreakdownInfos,
  CostBreakdownPieChart,
  CostBreakdownBarChart
};



// WEBPACK FOOTER //
// ./src/components/dashboard/aws/index.js